/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "RequestTiming": {
                "fields": {
                  "attemptCount": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional"
                  },
                  "previousAttemptPaymentId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "incomingDeadlineRemainingMs": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "paymentLockMs": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "processorLatencyMs": {
                    "type": "int64",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RequestTiming) {
  $root.addJSON(jsonData);
}

/**
 * Request timing information.
 *
 * SOURCE RequestTiming @ squareup/esperanto/model/request_metrics.proto at 10:1
 */
export const RequestTiming = $root.lookupType('squareup.esperanto.model.RequestTiming');
fixType(RequestTiming);
Builder.createAndAttachToType(RequestTiming);